<template>
  <ThemeV2 />
</template>

<script setup lang="ts">
import ThemeV2 from '@/wabunka-src/features/Theme/pages/ThemeV2/ThemeV2.vue';
// 境界線なし・白文字のヘッダー
definePageMeta({ layout: 'en-experience-id', headerBgTransparent: true });
</script>
